import { Card, Body1, Subtitle2, Caption1Strong, Caption1Stronger, Badge } from '@fluentui/react-components';
import { TResolvedSubmissionItem } from '../../../types/submissions.types';
import getRecentItemTransitions from '@modules/submissions/helpers/getRecentItemTransitions.helpers';
import { ESubmissionItemStatus } from '../../../types/submissions.types';
import { SmartTableCell } from '@shared/components';
import { formatSubmissionStatus } from '../../SubmissionStatusBadge';
import { ArrowRight12Filled } from '@fluentui/react-icons';
import { SUBMISSION_STATUS_COLORS_MAP } from '@modules/submissions/constants';

/**
 * A small helper to render "status" text with color.
 * You could also use a Badge if desired.
 */
const ColoredStatusText = ({ status, isStronger }: { status: ESubmissionItemStatus; isStronger?: boolean }) => {
  const color = SUBMISSION_STATUS_COLORS_MAP[status];
  const label = formatSubmissionStatus(status); // e.g. "In progress", "In review"
  const Component = isStronger ? Caption1Stronger : Caption1Strong;
  return (
    // We use a Badge for accessibility reasons, but we set the appearance to "ghost" to remove the background
    <Badge appearance="ghost" className="!p-0">
      <Component style={{ color }}>{label}</Component>
    </Badge>
  );
};

const MAX_ACTIVITIES = 5; // max number of activities to show

type TProps = {
  resolvedSelectedItems: TResolvedSubmissionItem[];
};

const SubmissionRecentActivitiesCard = ({ resolvedSelectedItems }: TProps) => {
  const transitions = getRecentItemTransitions(resolvedSelectedItems).slice(0, MAX_ACTIVITIES);

  return (
    <Card className="flex flex-col w-[333px]" size="large">
      <Subtitle2>Recent activities</Subtitle2>

      <div className="flex flex-col justify-start h-full gap-2">
        {transitions.length ? (
          transitions.map((t) => {
            return (
              <div key={t.resolvedItem._id}>
                <SmartTableCell
                  wrap="layout-only"
                  variant={{ kind: 'item', item: t.resolvedItem }}
                  tooltip={{ threshold: 31 }}
                  stackedBelow={
                    <div className="flex items-center gap-1">
                      <ColoredStatusText status={t.oldStatus} />
                      <ArrowRight12Filled />
                      <ColoredStatusText status={t.newStatus} isStronger />
                    </div>
                  }
                />
              </div>
            );
          })
        ) : (
          <Body1>No recent updates</Body1>
        )}
      </div>
    </Card>
  );
};

export default SubmissionRecentActivitiesCard;
